jQuery(function ($) {

  //mvスライダー
  $(".mv-main__slider")
    .on("init", function (event, slick) {
      $(this).append('<div class="slick-num"><span class="now-count"></span>/<span class="all-count"></span></div>');
      $(".now-count").text(slick.currentSlide + 1); // 現在のスライド番号(+1が無いと0からスタートしてしまう)
      $(".all-count").text(slick.slideCount); // スライドの総数
    })
    .slick({
      infinite: true,
      autoplay: true,
      prevArrow: '<div class="prev"></div>',
      nextArrow: '<div class="next"></div>',
      slidesToShow: 3,
      variableWidth: true,
      speed: 800,
      responsive: [{
        breakpoint: 940,
        settings: {
          slidesToShow: 1,
          variableWidth: false
        }
      }]
    })
    .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
      $(".now-count").text(nextSlide + 1); // 現在のスライド番号の次のスライドになったら番号を+1
    })
    .on("afterChange", function (event, slick, currentSlide, nextSlide) {
      $(".slick-slide").removeClass('is-current');
      $(".slick-current").addClass('is-current');
    });
    $('.slick-current').addClass('is-current');

  $('.wp-block-gallery').slick({
    autoplay: true,
    dots: true,
    prevArrow: '<div class="prev"></div>',
    nextArrow: '<div class="next"></div>'
  });

  //マーチャンダイジングスライダー
  var mainSlider = ".merchandising-slider__list"; //メインスライダーid
  var thumbnailSlider = ".merchandising-slider__thumbnail"; //サムネイルスライダーid

  //マーチャンダイジングスライダー:メイン
  $(mainSlider).slick({
    infinite: false,
    autoplay: false,
    dots: false,
    prevArrow: '<div class="prev"></div>',
    nextArrow: '<div class="next"></div>',
    asNavFor: thumbnailSlider
  });

  //マーチャンダイジングスライダー:サムネイル
  if (window.matchMedia('(max-width: 940px)').matches) {
    $(thumbnailSlider).slick({
      infinite: false,
      autoplay: false,
      arrows: false,
      dots: false,
      // variableWidth: true,
      slidesToShow: 3,
      asNavFor: mainSlider,
      focusOnSelect: true
    });
  } else {
    $(thumbnailSlider).slick({
      infinite: false,
      autoplay: false,
      // autoplay: true,
      arrows: false,
      // slidesToShow: 6,
      variableWidth: true,
      asNavFor: mainSlider,
      focusOnSelect: true
    });
  }

  //マーチャンダイジングスライダーmin
  $('.merchandising-slider__min__list').each(function () {
    var slidesToshow_leng = $(this).children(".merchandising-slider__min__list__item").length;
    console.log(slidesToshow_leng);
    if (window.matchMedia('(max-width: 940px)').matches) {
      if (slidesToshow_leng > 3) {
        $(this).slick({
          infinite: true,
          autoplay: true,
          prevArrow: '<div class="prev"></div>',
          nextArrow: '<div class="next"></div>',
          arrows: true,
          dots: true,
          variableWidth: true,
          speed: 500,
          slidesToShow: 3,
          slidesToScroll: 3
        });
      } else {
        $('.merchandising-slider__min__list').addClass('not-slide');
      }
    } else {
      if (slidesToshow_leng > 6) {
        $(this).slick({
          infinite: true,
          autoplay: true,
          prevArrow: '<div class="prev"></div>',
          nextArrow: '<div class="next"></div>',
          arrows: true,
          dots: false,
          variableWidth: true,
          speed: 500,
          slidesToShow: 6,
          slidesToScroll: 6
        });
      } else {
        $('.merchandising-slider__min__list').addClass('not-slide');
      }
    }
  });

  //TOPポートフォリオスライダー
  $('.products-slider__list').slick({
    infinite: true,
    autoplay: true,
    prevArrow: '<div class="prev"></div>',
    nextArrow: '<div class="next"></div>',
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: 940,
      settings: {
        slidesToShow: 1
      }
    }]
  });

  //TOP書籍スライダー
  if (window.matchMedia("(max-width: 940px)").matches) {
    do {
      $(".books-list").children(".books-list__item:lt(4)").wrapAll('<div class="sp-wrap"></div>')
    } while ($(".books-list").children(".books-list__item").length);
    $('.books-list').slick({
      prevArrow: '<div class="prev"> &#8592; </div>',
      nextArrow: '<div class="next"> &#8594; </div>',
    });
  };

  //マーチャンダイジングモーダル
  $('.modal-open').each(function () {
    $(this).on('click', function () {
      var target = $(this).data('target');
      var modal = document.getElementById(target);
      // $(modal).fadeIn();
      $(modal).addClass('is-active');
      return false;
    });
  });

  $('.modal-close').on('click', function () {
    $('.js-modal').removeClass('is-active');
    return false;
  });

  $('.modal-bg').on('click', function () {
    $('.js-modal').removeClass('is-active');
    return false;
  });

  //ページ内リンク
  $('a[href^="#"]').on('click', function () {
    let time = 400;
    let header = $('.header').height();
    let target = $(this.hash);
    if (!target.length) return;
    let targetY = target.offset().top - header;
    $('html,body').animate({
      scrollTop: targetY
    }, time, 'swing');
    return false;
  });

  //トップへ戻る
  var pagetop = $('.footer-content__top')
  pagetop.click(function () {
    $('body, html').animate({
      scrollTop: 0
    }, 500);
    return false;
  });

  //ヘッダー
  $(window).scroll(function () {
    var scroll = $(this).scrollTop();
    if (scroll > 0) {
      $('header').addClass('is-active');
    }
  });

  //ハンバーガーメニュー
  $('.header-hamburger').on('click', function () {
    $('.header-hamburger').toggleClass('is-active');
    $('.header-inner').toggleClass('is-active');
    $('header').toggleClass('is-open');
    $('body').toggleClass('js-nav__active');
  });

  $('.header-nav__item a').on('click', function () {
    $('.header-hamburger').removeClass('is-active');
    $('.header-inner').removeClass('is-active');
    $('header').removeClass('is-open');
    $('body').removeClass('js-nav__active');
  });

  //コンテンツフェードイン
  $(window).on('scroll', function () {
    $('.js-fadein').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).addClass('fadein');
      }
    });
    $('.js-fadein_slow').each(function () {
      var elemPos = $(this).offset().top,
        scroll = $(window).scrollTop(),
        windowHeight = $(window).height();
      if (scroll > elemPos - windowHeight + 100) {
        $(this).delay(500).queue(function () {
          $(this).addClass('fadein').dequeue();
        });
      }
    });
  });

  //シェアリンク生成
  var href = location.href; //1.URLを取得しエンコードする
  var getTitle = $('title').html(); //2.ページのタイトルを取得
  var snsUrl = encodeURIComponent(href);
  var snsTitle = encodeURIComponent(getTitle);

  $('.sns-link').each(function () {
    var sns_obj = $(this).attr('id'); //4.ID名を取得
    var snsCase = sns_obj;
    switch (snsCase) {
      case 'sns_twitter':
        $(this).attr('href', 'http://twitter.com/share?url=' + snsUrl);
        break;

      case 'sns_fb':
        $(this).attr('href', 'http://www.facebook.com/sharer.php?u=' + snsUrl);
        break;

      case 'sns_line':
        $(this).attr('href', 'http://line.me/R/msg/text/?' + snsTitle + '%20' + snsUrl);
        break;
    }
  });

  //MW WP FORM スクロール位置調整
  // if ($('.error')[0]) {
  //   $('.mw_wp_form').addClass('mw_wp_form_error');
  //   var errorEl = $('.mw_wp_form').eq(0);
  //   var position = errorEl.parent().offset().top - 85;
  //   $('body,html').delay(200).animate({
  //     scrollTop: position
  //   }, 600, 'swing');
  // }

  //ニュースタグ
  var href = location.href;
  $('.news-archive__search__list__item').each(function () {
    var id = $(this).attr('id');
    if (location.href.match(id)) {
      $('.news-archive__search__list__item').removeClass('is-active');
      $(this).addClass('is-active');
    };
  });

  //ニュースSPアコーディオン
  $('.news-archive__search p').on('click', function () {
    $(this).next('.news-archive__search__list').slideToggle();
    $(this).toggleClass('is-open');
  });

  //fixedアイテムをフッターにきたら非表示
  var footer = $('.footer').innerHeight(); // footerの高さを取得
  $(window).scroll(function () {
    var point = window.pageYOffset; // 現在のスクロール地点 
    var docHeight = $(document).height(); // ドキュメントの高さ
    var dispHeight = $(window).height(); // 表示領域の高さ

    if (point > docHeight - dispHeight - footer) { // スクロール地点>ドキュメントの高さ-表示領域-footerの高さ
      if (window.matchMedia("(min-width: 940px)").matches) {
        $('.fixed-sns').fadeOut();
        $('.fixed-btn').fadeOut();
      }
    } else {
      $('.fixed-btn').fadeIn();
      if (window.matchMedia("(min-width: 940px)").matches) {
        $('.fixed-btn').fadeIn();
        $('.fixed-sns').fadeIn();
      }
    }
  });
});

//loading
function disableScroll(event) {
  event.preventDefault();
}

if (window.document.body.id === 'top') {
  document.addEventListener('touchmove', disableScroll, {
    passive: false
  });

  document.addEventListener('mousewheel', disableScroll, {
    passive: false
  });
}

const loader = document.getElementsByClassName('loading');
const wrapper = document.getElementsByClassName('front');

var webStorage = function () {
  if (sessionStorage.getItem('access')) {
    /*2回目以降アクセス時の処理*/
    console.log('2回目');
    wrapper[0].classList.add('is-shown');
    document.removeEventListener('touchmove', disableScroll, {
      passive: false
    });
    document.removeEventListener('mousewheel', disableScroll, {
      passive: false
    });
  } else {
    /*初回アクセス時の処理*/
    sessionStorage.setItem('access', 'true'); // sessionStorageにデータを保存
    console.log('1回目');
    var h = $(window).height();
    $('.loading').height(h).css('display', 'flex');
    const loaderFade = () => {
      loader[0].classList.add('loader-fadeout');
      wrapper[0].classList.add('is-shown');
      document.removeEventListener('touchmove', disableScroll, {
        passive: false
      });
      document.removeEventListener('mousewheel', disableScroll, {
        passive: false
      });
    }
    window.onload = function () {
      setTimeout(loaderFade, 2000);
    };
  }
}
webStorage();

//8秒たったら強制的にロード画面を非表示
jQuery(function ($) {
  setTimeout('stopload()', 8000);
});

function stopload() {
  $('.front').css('display', 'block');
  $('.loading').delay(600).fadeOut(300);
}

//SP時MVパララックス
if (window.matchMedia("(max-width: 940px)").matches) {
  var rellax = new Rellax('.rellax');
};